import { Injectable } from '@angular/core';
import { AbcCore, CompareHelper } from '@barthauer/abc/core';
import { ConfigService } from 'libs/abc/core/configuration/src/lib/services/config.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WorkerResult } from '../models/import.model';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private extensionWorkersCurrentStateUri: string;
  private extensionWorkersResultUri: string;
  private extensionWorkersCancelUri: string;
  constructor(private configService: ConfigService, private abcCore: AbcCore) {
    this.extensionWorkersCurrentStateUri =
      this.configService.configuration.WebApi.ServiceURLs.ExtensionWorkersCurrentState;
    this.extensionWorkersResultUri = this.configService.configuration.WebApi.ServiceURLs.ExtensionWorkersResult;
    this.extensionWorkersCancelUri = this.configService.configuration.WebApi.ServiceURLs.ExtensionWorkersCancel;
  }

  public getExtensionWorkersCurrentState(inputResult: WorkerResult): Observable<WorkerResult> {
    return this.abcCore.data.executeWebApiPOSTMethod(this.extensionWorkersCurrentStateUri, inputResult, true).pipe(
      map((data) => (!CompareHelper.isEmptyObject(data) ? (data as any) : null)),
      map((data) => new WorkerResult(data))
    );
  }

  public getExtensionWorkersResult(inputResult: WorkerResult): Observable<any> {
    return this.abcCore.data
      .executeWebApiPOSTMethodBlob(this.extensionWorkersResultUri, inputResult, true)
      .pipe(map((data) => (!CompareHelper.isEmptyObject(data) ? (data as any) : null)));
  }

  public cancelExtensionWorker(inputResult: WorkerResult): Observable<any> {
    return this.abcCore.data
      .executeWebApiPOSTMethod(this.extensionWorkersCancelUri, inputResult, true)
      .pipe(map((data) => (!CompareHelper.isEmptyObject(data) ? (data as any) : null)));
  }
}
